import CryptoJS from 'crypto-es';
import { Action, ActionReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { constants } from '@shared/constants';

const encryptFunction = (str?: string): string => {
  if (!str) {
    return '';
  }

  try {
    return CryptoJS.AES.encrypt(str, constants.ENCRYPTION_KEY).toString();
  } catch {
    return '';
  }
};
const decryptFunction = (str?: string): string => {
  if (!str) {
    return '';
  }

  try {
    return CryptoJS.AES.decrypt(str, constants.ENCRYPTION_KEY).toString(CryptoJS.enc.Utf8);
  } catch {
    return '';
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const localStorageSyncMetaReducer = <T, V extends Action = Action>(reducer: ActionReducer<any>): ActionReducer<T, V> => {
  return (state, action) => {
    return localStorageSync({
      keys: [
        {
          auth: {
            encrypt: encryptFunction,
            decrypt: decryptFunction,
          },
        },
        {
          featureFlag: {
            encrypt: encryptFunction,
            decrypt: decryptFunction,
          },
        },
      ],
      rehydrate: true,
      removeOnUndefined: true,
      restoreDates: false,
      storage: window.localStorage,
      storageKeySerializer: (key: string) => `rkor_admin_${key}`,
    })(reducer)(state, action);
  };
};
